import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { DIAL_COUNTRIES } from "@/lib/phone";

export function CountryCodePicker({ value, onChange, testid = "contact" }) {
  const [open, setOpen] = useState(false);
  const cur = DIAL_COUNTRIES.find((c) => c.iso === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" aria-label="Country code" data-testid={`${testid}-country-trigger`} className="flex h-11 w-[118px] shrink-0 items-center gap-1.5 rounded-xl border border-slate-200 bg-white px-3 text-sm font-semibold text-slate-900 outline-none transition-colors hover:border-slate-400 focus:border-slate-900">
          <span className="rounded bg-slate-900 px-1 font-mono text-[10px] text-amber-400">{cur?.iso || "--"}</span>
          <span data-testid={`${testid}-dial-code`}>{cur?.dial || "+"}</span>
          <ChevronsUpDown className="ml-auto h-3.5 w-3.5 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="start" data-testid={`${testid}-country-list`}>
        <Command>
          <CommandInput placeholder="Search country or code" data-testid={`${testid}-country-search`} />
          <CommandList className="max-h-64">
            <CommandEmpty>No country found</CommandEmpty>
            <CommandGroup>
              {DIAL_COUNTRIES.map((c) => (
                <CommandItem key={c.iso} value={`${c.name} ${c.iso} ${c.dial}`} onSelect={() => { onChange(c.iso); setOpen(false); }} data-testid={`${testid}-country-${c.iso}`}>
                  <span className="w-7 font-mono text-[11px] font-bold text-slate-500">{c.iso}</span>
                  <span className="flex-1 truncate">{c.name}</span>
                  <span className="font-mono text-xs text-slate-500">{c.dial}</span>
                  {c.iso === value && <Check className="ml-1 h-3.5 w-3.5 text-emerald-600" />}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
